import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { AppState, PrintLabelAttrs, labelEditorSlice } from 'cdx-common';
import { useSelector } from 'react-redux';
import { appStore } from '../../../store';

export const NewPrintLabelOptions = (props: { paperName: string, printLabels: PrintLabelAttrs[], onEmptyClick: () => void; }) => {

    const selectedPrintLabel = useSelector((state: AppState) => state.labelEditor.selectedPrintLabel);

    return <FormControl fullWidth>
        <InputLabel>Gabarit</InputLabel>
        <Select
            size='small'
            label="Gabarit"
            value={selectedPrintLabel ? (selectedPrintLabel.paperName == props.paperName ? selectedPrintLabel.printLabelId : 'empty') : 'empty'}
        >
            <MenuItem key='empty' value={'empty'} onClick={() => {
                appStore.dispatch(labelEditorSlice.actions.setSelectedPrintLabel({
                    paperName: props.paperName,
                    printLabelId: 'empty'
                }));
            }}>Étiquette vide</MenuItem>
            {props.printLabels.map(p => <MenuItem key={p.id} value={p.id} onClick={() => {
                appStore.dispatch(labelEditorSlice.actions.setSelectedPrintLabel({
                    paperName: props.paperName,
                    printLabelId: p.id
                }));
            }}>{p.name}</MenuItem>)}
        </Select>
    </FormControl>;
};
